export const GET_HIGHLIGHT_SUMMARY_REQUEST = "get/highlight-summary/request";
export const GET_HIGHLIGHT_SUMMARY_ERROR = "get/highlight-summary/error";
export const GET_HIGHLIGHT_SUMMARY_SUCCESS = "get/highlight-summary/success";
